import { Badge, IconButton, Tooltip } from "@mui/material"
import NoteAddIcon from "@mui/icons-material/NoteAdd"
import { NoteTarget, useUserNotes } from "./UserNotesContext"

export const UserNotesButton = ({ target, title }: { target: NoteTarget, title: string }) => {
    const { openNotes, countNotesFor } = useUserNotes()

    return <Tooltip title={title}>
        <IconButton size="small" aria-label={title} onClick={() => openNotes(target)}>
            <Badge color="warning" badgeContent={countNotesFor(target.objectType, target.objectGuid)}>
                <NoteAddIcon fontSize="small" />
            </Badge>
        </IconButton>
    </Tooltip>
}
